import { toast } from "react-toastify";
import { Services } from "../../../api/Services";

export const useExerciseOperations = (state, workoutDetail) => {
  const {
    pid,
    wid,
    widd,
    setisLoading,
    setisLoad,
    setApiExercises,
    setMergeExercises,
    setInputValues,
    setSelectedDays,
    setWorkoutData,
    setExerciseList,
    setGeneralFields,
    setWeeks,
    setWorkoutExercise,
    setExcerciseModal,
    setSelectedExercise,
    setSelectedExerciseEmom,
    setQuickSet,
    setMerge,
    setSelectedExerciseIds,
    setMvideo,
    setRemoveMerge,
    setSelectedExerciseremoveIds,
    setMergeId,
    setActionModalMessage,
    setActionButtonTitle,
    setSelectedActionObjType,
    setSelectedActionObj,
    setSelectedActionObj2,
    setConfirmActionModal,
    selectedExerciseIds,
    selectedExerciseremoveIds,
    mvideo,
    mergeId,
    apiexercises,
    workoutExercise,
    selectedExercise,
    selectedExerciseEmom,
    inputValues,
    selectedActionObjType,
    selectedActionObj,
    selectedActionObj2,
  } = state;

  // Merge exercise operations
  const handleExerciseClickk = (workoutExerciseId) => {
    if (
      selectedExerciseIds.some(
        (item) => item.workout_exercise_id === workoutExerciseId
      )
    ) {
      setSelectedExerciseIds((prevIds) =>
        prevIds.filter((item) => item.workout_exercise_id !== workoutExerciseId)
      );
    } else {
      setSelectedExerciseIds((prevIds) => [
        ...prevIds,
        { workout_exercise_id: workoutExerciseId },
      ]);
    }
  };

  const handleExerciseClickRemove = (workoutExerciseId) => {
    if (
      selectedExerciseremoveIds.some(
        (item) => item.workout_exercise_id === workoutExerciseId
      )
    ) {
      setSelectedExerciseremoveIds((prevIds) =>
        prevIds.filter((item) => item.workout_exercise_id !== workoutExerciseId)
      );
    } else {
      setSelectedExerciseremoveIds((prevIds) => [
        ...prevIds,
        { workout_exercise_id: workoutExerciseId },
      ]);
    }
  };

  const openMergeModal = () => {
    setMvideo("");
    setMerge(true);
    setSelectedExerciseIds([]);
  };

  const openRemoveModal = (mergid) => {
    setMergeId(mergid);
    setSelectedExerciseremoveIds([]);
    setRemoveMerge(true);
  };

  // API Operations
  const mergeExercisesNow = async (data) => {
    if (selectedExerciseIds.length < 2) {
      setSelectedExerciseIds([]);
      toast.error("please select atlease two exercises", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setisLoad(true);
      try {
        const result = await Services.mergeExercises(data);

        if (result.status === 200) {
          toast.success(result?.data?.message, {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setisLoad(false);
          setTimeout(() => {
            setMerge(false);
            setSelectedExerciseIds([]);
            setMvideo("");
            workoutDetail(wid || widd);
          }, 1500);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setisLoad(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const removeMergeNow = async (data) => {
    if (selectedExerciseremoveIds.length < 1) {
      setSelectedExerciseremoveIds([]);
      toast.error("please select atleaset one exercise", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setisLoad(true);
      try {
        const result = await Services.mergeExercises(data);

        if (result.status === 200) {
          toast.success(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setisLoad(false);
          setTimeout(() => {
            setRemoveMerge(false);
            setSelectedExerciseremoveIds([]);
            setMergeId("");
            workoutDetail(wid || widd);
          }, 1500);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Exercise operations
  const handleExerciseClick = (exercise) => {
    setSelectedExercise(exercise);
  };

  const handleModalClose = () => {
    setSelectedExercise(null);
  };

  const handleModalCloseEmom = () => {
    setSelectedExerciseEmom(null);
  };

  const handleAddSetClick = () => {
    if (selectedExercise) {
      const lastSet = selectedExercise?.sets[selectedExercise.sets.length - 1];
      const newSet = {
        id: Math.floor(Math.random() * 99999),
        inputs: lastSet?.inputs?.map((input) => ({
          ...input,
          id: Math.floor(Math.random() * 99999),
          value: input.value !== null ? input.value : 0,
        })),
      };

      setSelectedExercise((prevExercise) => ({
        ...prevExercise,
        sets: [...prevExercise.sets, newSet],
      }));
    }
  };

  const handleSaveSet = async () => {
    if (selectedExercise) {
      const formattedData = {
        workout_id: wid || widd,
        program_id: pid,
        exercises: [
          {
            exercise: {
              id: selectedExercise.id,
              exercise_id: selectedExercise.exercise_id,
              sets: selectedExercise.sets.map((set) => ({
                id: set.id,
                fields: set?.inputs?.map((field) => ({
                  field_name: field?.field_name,
                  id: field?.id,
                  value: field?.value,
                  type: field?.type,
                  field_id: field?.exercise_criteria_id,
                  unit: field?.unit,
                })),
              })),
            },
          },
        ],
      };

      try {
        setisLoading(true);
        const result = await Services.addWorkoutSets(formattedData);
        if (result.status === 200) {
          toast.success("Exercise sets added successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            workoutDetail(wid || widd);
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSaveSetEmom = async () => {
    if (selectedExerciseEmom) {
      const formattedData = {
        workout_id: wid || widd,
        program_id: pid,
        exercises: [
          {
            exercise: {
              id: selectedExerciseEmom.id,
              exercise_id: selectedExerciseEmom.exercise_id,
              sets: selectedExerciseEmom.sets.map((set) => ({
                id: set.id,
                fields: set?.inputs?.map((field) => ({
                  field_name: field?.field_name,
                  id: field?.id,
                  value: field?.value,
                  type: field?.type,
                  field_id: field?.exercise_criteria_id,
                  unit: field?.unit,
                })),
              })),
            },
          },
        ],
      };

      try {
        setisLoading(true);
        const result = await Services.addWorkoutSets(formattedData);
        if (result.status === 200) {
          toast.success("Exercise sets added successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            workoutDetail(wid || widd);
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleQuickSaveSet = async () => {
    try {
      setisLoading(true);
      const updatedInputValues = { ...inputValues };

      const formattedData = {
        workout_id: wid || widd,
        program_id: pid,
        exercises: apiexercises?.map((exercise) => {
          const firstSetInputs = exercise?.sets[0]?.inputs.map((field) => ({
            field_name: field?.field_name,
            id: field?.id,
            value:
              updatedInputValues[
                `${exercise.id}_${exercise.sets[0].id}_${field.id}`
              ],
            type: field?.type,
            field_id: field?.exercise_criteria_id,
            unit: field.unit,
          }));

          const updatedSets = exercise?.sets.map((set) => ({
            id: set.id,
            fields: set.inputs.map((field, fieldIndex) => ({
              field_name: field.field_name,
              id: field.id,
              value: firstSetInputs[fieldIndex]?.value,
              type: field.type,
              field_id: field.exercise_criteria_id,
              unit: field.unit,
            })),
          }));

          return {
            exercise: {
              id: exercise.id,
              exercise_id: exercise.exercise_id,
              sets: updatedSets,
            },
          };
        }),
      };

      const result = await Services.addWorkoutSets(formattedData);
      if (result.status === 200) {
        setInputValues({});
        toast.success("Exercise sets added successfully!", {
          autoClose: 1500,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => {
          workoutDetail(wid || widd);
        }, 2000);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  // Delete operations
  const deleteEx = async (wid, exid) => {
    setActionModalMessage("Do you want to delete this exercise?");
    setActionButtonTitle("Delete");
    setSelectedActionObjType("exercise");
    setSelectedActionObj(exid);
    setSelectedActionObj2(wid);
    setConfirmActionModal(true);
  };

  const deleteSets = async (setid, wid) => {
    setActionModalMessage("Do you want to delete this exercise set?");
    setActionButtonTitle("Delete");
    setSelectedActionObjType("set");
    setSelectedActionObj(setid);
    setSelectedActionObj2(wid);
    setConfirmActionModal(true);
  };

  const duplicateEx = async (pid, wid, exid) => {
    const confirmed = window.confirm("Do you want to duplicate this exercise?");
    if (confirmed) {
      setisLoading(true);
      try {
        const result = await Services.duplicateExcercise(pid, wid, exid);
        if (result.status === 200) {
          toast.success("Exercise duplicated successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            workoutDetail(wid || widd);
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleActionConfirmed = async () => {
    if (selectedActionObjType === "exercise") {
      try {
        let exid = selectedActionObj;
        let wid = selectedActionObj2;
        const result = await Services.deleteExcercise(wid, exid);
        if (result.status === 200) {
          toast.success("Exercise deleted successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            workoutDetail(wid || widd);
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
      }
    } else if (selectedActionObjType === "set") {
      try {
        setisLoading(true);
        let setid = selectedActionObj;
        let wid = selectedActionObj2;
        const result = await Services.deleteSet(setid, wid);
        if (result.status === 200) {
          toast.success("Exercise set deleted successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          const updatedSets = selectedExercise.sets.filter(
            (set) => set.id !== setid
          );
          setSelectedExercise((prevExercise) => ({
            ...prevExercise,
            sets: updatedSets,
          }));
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  return {
    handleExerciseClickk,
    handleExerciseClickRemove,
    openMergeModal,
    openRemoveModal,
    mergeExercisesNow,
    removeMergeNow,
    handleExerciseClick,
    handleModalClose,
    handleModalCloseEmom,
    handleAddSetClick,
    handleSaveSet,
    handleSaveSetEmom,
    handleQuickSaveSet,
    deleteEx,
    deleteSets,
    duplicateEx,
    handleActionConfirmed,
  };
};
